import React from 'react';
import { connect } from 'react-redux';

import { setDialogContentProp } from '../../actions/dialog';
import ManageDevis from '../Devis/ManageDevis';

const setManaging = setDialogContentProp('managing');

const mapDispatchToProps = {
  setManaging,
};

const ValidateDevisSuppDialog = ({ setManaging }) => (
  <ManageDevis setManaging={setManaging} />
);

export default connect(null, mapDispatchToProps)(ValidateDevisSuppDialog);
